export default {
  PX: 'px',
};
